import { useEffect, useState } from "react";
import { EmptyState, StatusBadge } from "@/components/shared/Common";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";

const COND = { buena: "Buena", danada: "Con daño", mantencion: "Para mantención" };
const days = (v) => Math.floor((Date.now() - new Date(v.endsWith?.("Z") ? v : v + "Z").getTime()) / 86400000);

export const EmployeeTools = ({ employeeId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/abastecimiento/tools/by-employee/${employeeId}`).then((r) => setD(r.data)); }, [employeeId]);
  if (!d) return <div className="text-[#5b6656] text-sm">Cargando…</div>;
  return (
    <div className="space-y-5" data-testid="employee-tools">
      <div className="syc-card overflow-hidden">
        <div className="px-5 py-3 border-b border-[#e4e8e1] font-bold" data-testid="employee-tools-count">En su poder ({d.holding.length})</div>
        {d.holding.length === 0 ? <EmptyState title="No tiene herramientas entregadas" /> : d.holding.map((t) => (
          <div key={t.id} data-testid={`emp-tool-${t.code}`} className="flex flex-wrap items-center gap-3 px-5 py-3 border-b border-[#f0f2ee] text-sm">
            <span className="font-mono text-xs w-24">{t.code}</span>
            <div className="flex-1 min-w-[160px]"><div className="font-semibold">{t.product_name}</div><div className="text-xs text-[#5b6656]">{[t.brand, t.model, t.serial && `S/N ${t.serial}`].filter(Boolean).join(" · ")}</div></div>
            <span className="text-xs">{t.ot_code} · desde {fmtDateTime(t.delivered_at)}</span>
            <StatusBadge status={days(t.delivered_at) >= 1 ? "pendiente" : "info"} label={`${days(t.delivered_at)} día(s)`} />
          </div>))}
      </div>
      <div className="syc-card overflow-hidden">
        <div className="px-5 py-3 border-b border-[#e4e8e1] font-bold">Historial de entregas y devoluciones</div>
        {d.events.length === 0 ? <EmptyState title="Sin movimientos" /> : d.events.map((e, i) => (
          <div key={i} data-testid={`emp-tool-event-${i}`} className="flex flex-wrap items-center gap-3 px-5 py-2.5 border-b border-[#f0f2ee] text-sm">
            <span className="text-xs w-32 text-[#5b6656]">{fmtDateTime(e.ts)}</span>
            <StatusBadge status={e.type === "entrega" ? "info" : "activo"} label={e.type === "entrega" ? "Entrega" : "Devolución"} />
            <span className="font-mono text-xs">{e.code}</span>
            <span className="flex-1 text-xs text-[#5b6656]">{[e.ot_code, e.warehouse_code, e.condition && COND[e.condition], e.note].filter(Boolean).join(" · ")}</span>
            <span className="text-xs text-[#8a9584]">{e.user_name}</span>
          </div>))}
      </div>
    </div>
  );
};
